<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="700.000000pt" height="700.000000pt" viewBox="0 0 700.000000 700.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.11, written by Peter Selinger 2001-2013
</metadata>
<g transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M1326 5775 c3 -22 8 -49 10 -60 2 -11 6 -38 9 -60 3 -22 17 -107 31
-190 14 -82 27 -161 29 -175 2 -14 13 -81 25 -150 25 -152 26 -158 40 -245 10
-66 13 -84 25 -155 8 -46 12 -74 35 -215 34 -214 34 -214 55 -335 18 -108 20
-121 34 -210 6 -36 13 -83 17 -104 3 -22 10 -49 14 -62 5 -12 7 -24 4 -27 -3
-2 50 -59 116 -126 l121 -121 59 0 c33 0 60 -3 60 -7 0 -5 -79 -7 -175 -6 -96
1 -177 -2 -179 -6 -5 -7 -9 -87 -21 -366 -3 -66 -7 -163 -10 -215 -3 -52 -7
-158 -10 -235 -6 -138 -10 -225 -20 -440 -3 -60 -7 -162 -10 -225 -4 -105 -8
-191 -20 -443 l-4 -88 602 4 c651 4 647 4 820 62 39 14 72 23 74 21 5 -5 -74
-33 -157 -56 -151 -41 -226 -45 -818 -44 -282 0 -511 -3 -510 -7 2 -4 68 -74
148 -155 l145 -148 475 0 c261 0 509 3 550 7 635 56 1058 483 1063 1072 2 168
-12 255 -60 375 -53 131 -111 213 -260 366 -59 61 -139 146 -177 188 -105 119
-222 198 -369 252 -83 30 -79 29 -135 39 -24 4 -39 11 -33 14 6 4 64 117 129
251 66 135 174 358 242 495 67 138 133 274 147 303 13 30 26 52 28 50 2 -1 5
-16 8 -33 3 -16 13 -75 22 -130 9 -55 18 -111 20 -125 2 -14 6 -41 10 -60 13
-77 24 -147 29 -180 3 -19 12 -74 21 -123 8 -48 17 -102 19 -120 3 -17 7 -45
10 -62 3 -16 19 -115 36 -220 17 -104 32 -199 34 -210 2 -11 14 -81 26 -156
l22 -136 478 0 478 0 80 166 c45 91 121 249 170 351 49 102 122 253 162 335
40 83 104 215 143 295 38 80 108 224 155 320 46 96 104 216 127 265 24 50 64
132 89 184 25 52 44 96 41 99 -3 4 -640 6 -741 3 -17 -1 -31 -25 -79 -138 -31
-76 -66 -156 -76 -178 -10 -22 -69 -157 -130 -300 -61 -143 -115 -264 -120
-269 -5 -6 -9 3 -10 25 0 18 -2 43 -4 54 -2 11 -7 43 -11 70 -3 28 -8 61 -9
75 -19 144 -45 342 -45 346 0 3 -42 49 -94 102 -52 53 -120 123 -151 155 l-56
58 -214 1 c-118 1 -215 3 -215 5 0 3 7 17 15 31 23 42 195 403 195 411 0 3
-67 73 -150 154 -131 130 -170 159 -170 128 0 -5 -60 -131 -134 -282 -73 -151
-182 -373 -240 -494 -284 -582 -320 -655 -323 -651 -2 1 51 115 118 252 67
137 140 290 164 339 44 93 124 259 302 625 57 118 105 219 106 225 1 6 -142 9
-380 10 l-381 1 -193 -448 c-105 -247 -193 -447 -194 -446 -2 2 -10 62 -20
133 -9 72 -18 141 -21 155 -2 14 -6 49 -10 78 -3 29 -7 63 -10 75 -2 12 -7 49
-10 82 -7 58 -8 61 -94 150 -48 49 -116 119 -150 155 l-63 65 -364 0 -364 1 7
-41z m1495 -1551 c-33 -66 -60 -116 -60 -112 -1 11 113 238 117 234 2 -2 -24
-57 -57 -122z m-93 -189 c-18 -35 -34 -63 -36 -61 -4 5 56 126 63 126 3 0 -10
-29 -27 -65z m-62 -127 c-9 -12 -16 -19 -16 -15 0 11 24 47 28 42 2 -2 -3 -14
-12 -27z m-16 -36 c0 -5 -7 -17 -15 -28 -14 -18 -14 -17 -4 9 12 27 19 34 19
19z m-35 -71 c-3 -6 -14 -10 -23 -10 -15 1 -15 2 1 6 9 2 17 9 17 15 0 6 3 9
6 5 3 -3 3 -10 -1 -16z m-918 -7 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17
-2 13 -5z m56 -1 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60
0 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2
-30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24
-2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0
c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2
-30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24
-2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0
c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2
-30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z m-483 -263 c0 -5 -7 -7 -15 -4 -8 4 -15 8 -15 10 0
2 7 4 15 4 8 0 15 -4 15 -10z m100 2 c0 -4 -17 -6 -37 -4 -59 5 -63 10 -10 11
26 1 47 -3 47 -7z m120 0 c0 -4 -19 -6 -42 -4 -71 5 -77 10 -15 11 31 0 57 -2
57 -7z m80 0 c0 -4 -16 -6 -35 -4 -19 2 -35 6 -35 8 0 2 16 4 35 4 19 0 35 -4
35 -8z m80 0 c0 -4 -16 -6 -35 -4 -19 2 -35 6 -35 8 0 2 16 4 35 4 19 0 35 -4
35 -8z m80 0 c0 -4 -16 -6 -35 -4 -19 2 -35 6 -35 8 0 2 16 4 35 4 19 0 35 -4
35 -8z m120 -2 c0 -7 -102 -1 -109 6 -3 3 21 4 52 3 31 -1 57 -5 57 -9z m120
-5 c8 -2 -13 -3 -47 -3 -34 1 -60 4 -58 7 3 6 75 4 105 -4z m71 -13 c-18 -2
-37 0 -42 5 -5 5 11 6 34 3 41 -4 41 -5 8 -8z m72 -9 c-7 -2 -19 -2 -25 0 -7
3 -2 5 12 5 14 0 19 -2 13 -5z m37 -853 c11 -18 4 -208 -10 -265 -38 -151
-121 -239 -265 -281 -63 -18 -365 -28 -365 -12 0 6 239 14 273 9 4 0 8 5 8 11
3 28 21 429 23 503 1 22 6 42 13 45 7 3 80 4 164 4 108 -1 153 -5 159 -14z
m196 -1025 c-11 -8 -25 -15 -30 -15 -6 1 0 7 14 15 32 19 40 18 16 0z"/>
<path d="M5656 5035 c-9 -13 -16 -26 -16 -28 0 -3 -52 -112 -116 -243 -64
-132 -147 -302 -184 -379 -37 -77 -111 -230 -165 -340 -53 -110 -129 -265
-168 -345 -38 -80 -127 -263 -198 -407 l-128 -263 -483 0 -483 0 155 -155 155
-155 280 0 c154 0 371 0 483 0 l203 0 101 208 c55 114 124 257 153 317 29 61
108 223 175 360 120 246 187 384 340 700 42 88 107 221 144 296 36 75 66 141
66 147 0 5 -67 78 -149 161 l-149 151 -16 -25z"/>
</g>
</svg>
